<script lang="ts">
  import type { TierName } from '@bond/bruce-api/common/tier'

  export let tier: TierName
</script>

<div class="badge {tier}">
  {tier}
</div>

<style lang="scss">
  .badge {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    text-transform: uppercase;
    padding: 0.25em 0.5em;
    border-radius: 0.5em;
    height: 1.5em;
    max-width: max-content;
  }

  .Base {
    background-color: var(--base);
    color: var(--on-base);
  }

  .Black {
    background-color: var(--black);
    color: var(--on-black);
    border: solid 1px var(--tier-black-border);
  }

  .Epic {
    background-color: var(--epic);
    color: var(--on-epic);
  }
</style>
